import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Icons from "../../../Config/Images";
import { getWishlistAPI } from "../../../Store/Action/wishlistAction";
import Footer from "../Layout/Footer/Footer";
import Header from "../Layout/Header/Header";
import EmptyWishlistPage from "./EmptyWishlistPage";
import "./Wishlist.css";
import WishlistCardSection from "./WishlistCard";
import CustomLoader from "../CustomComponents/CustomLoader/CustomLoader";
import ShopByCategorySlider from "../ShopByCategorySlider";
import { getLoggedInUserDetailsAPI } from "../../../Store/Action/UserAction";

const Wishlist = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [isWastageEnabled, setIsWastageEnabled] = useState(true);

  //get wishlist
  useEffect(() => {
    dispatch(
      getWishlistAPI({}, (result) => {
        setWishlistItems(result?.data || []);
        setLoading(false);
      })
    );
  }, [dispatch]);

  //navigate to home route
  const handleBackClick = () => {
    navigate("/");
  };

  const onFetchGetWishlist = useCallback(() => {
    dispatch(
      getWishlistAPI({}, (result) => {
        setWishlistItems(result?.data || []);
        setLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setUserRole(result?.data?.[0]?.user_role_name);
        const booleanValue =
          result?.data?.[0]?.user_generic_data_value?.[0]
            ?.user_generic_data_boolean_value;

        if (typeof booleanValue === "boolean") {
          setIsWastageEnabled(booleanValue);
        } else if (booleanValue === 0 || booleanValue === 1) {
          setIsWastageEnabled(booleanValue === 1);
        }
      })
    );
  }, [dispatch]);
  return (
    <>
      <div className="wishlistMainDiv">
        <Header />
        {loading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : wishlistItems?.length === 0 ? (
          <>
            <EmptyWishlistPage />
          </>
        ) : (
          <>
            {/* <div className="wishlist-heading">
              <div className="back-to-home">
                <img
                  style={{ height: "30px", width: "30px" }}
                  src={Icons.backArrowIcon}
                  alt="Back"
                  onClick={handleBackClick}
                />
                <h4>Back to home</h4>
              </div>
              <div className="heading-text">
                <h3>Wishlist</h3>
              </div>
            </div> */}
            {/* <Header /> */}

            <p className="wishlist-title">Wishlist</p>
            <div className="wishlistCardsDiv">
              {wishlistItems?.map((prod, index) => (
                <WishlistCardSection
                  key={index}
                  image={`${prod?.product_image?.product_image_url}`}
                  title={
                    prod.product_sub_category_name
                      ? prod?.product_sub_category_name
                      : prod?.product_name
                  }
                  netWeight={prod.product_net_weight || "N/A"}
                  wastage={prod.product_wastage}
                  fine={
                    userRole == "retailer"
                      ? prod.product_retailer_per_pcs_fine
                      : prod.product_whole_seller_per_pcs_fine || "N/A"
                  }
                  product={prod}
                  isWishlist={prod.isWishlist}
                  isWishlistVisited={true}
                  onGetWishlistProduct={onFetchGetWishlist}
                  userRole={userRole} // ✅ Passing userRole
                  isWastageEnabled={isWastageEnabled} // ✅ Passing isWastageEnabled
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* <ShopByCategorySlider /> */}
      <Footer />
    </>
  );
};

export default Wishlist;
